// Слова из демо ждут регистрации (владелец 2026-10-25: «создать аккаунт с модулем оттуда, чтобы их сразу можно было
// заучивать»). Итоги демо кладут выбранные слова в localStorage и ведут на регистрацию с `?next=/demo/words`; та страница
// после входа и знакомства сохраняет их в модуль «Выживи в Лондоне» и открывает его. Срок — сутки: позже слова уже
// не ждут. Без импортов приложения: проверяет tests/demo-words.test.ts.

export const DEMO_WORDS_KEY = 'lx.demo.words';
export const DEMO_WORDS_TTL_MS = 24 * 60 * 60 * 1000;
export const DEMO_WORDS_MAX = 20;

export interface DemoWord {
  en: string;
  ru: string;
}

type KeyValueStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

function localStore(): KeyValueStore | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null; // хранилище заблокировано настройками приватности
  }
}

/** Слова из сохранённой строки — без пустых, повторов и лишних полей, не больше `DEMO_WORDS_MAX`; устарело — null. */
export function parseDemoWords(raw: string | null, now: number): DemoWord[] | null {
  if (!raw) return null;
  let data: unknown;
  try {
    data = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!data || typeof data !== 'object') return null;
  const { at, words } = data as { at?: unknown; words?: unknown };
  if (typeof at !== 'number' || now - at > DEMO_WORDS_TTL_MS || now < at - 60_000 || !Array.isArray(words)) return null;
  const seen = new Set<string>();
  const out: DemoWord[] = [];
  for (const w of words) {
    if (!w || typeof w !== 'object') continue;
    const en = typeof (w as DemoWord).en === 'string' ? (w as DemoWord).en.trim().slice(0, 120) : '';
    const ru = typeof (w as DemoWord).ru === 'string' ? (w as DemoWord).ru.trim().slice(0, 200) : '';
    if (!en || !ru || seen.has(en.toLowerCase())) continue;
    seen.add(en.toLowerCase());
    out.push({ en, ru });
    if (out.length >= DEMO_WORDS_MAX) break;
  }
  return out.length ? out : null;
}

export function stashDemoWords(words: DemoWord[], store: KeyValueStore | null = localStore(), now = Date.now()): void {
  try {
    store?.setItem(DEMO_WORDS_KEY, JSON.stringify({ at: now, words: words.slice(0, DEMO_WORDS_MAX) }));
  } catch {
    // без хранилища слова не дождутся регистрации — модуль можно собрать вручную
  }
}

export function readDemoWords(store: KeyValueStore | null = localStore(), now = Date.now()): DemoWord[] | null {
  try {
    return parseDemoWords(store?.getItem(DEMO_WORDS_KEY) ?? null, now);
  } catch {
    return null;
  }
}

export function clearDemoWords(store: KeyValueStore | null = localStore()): void {
  try {
    store?.removeItem(DEMO_WORDS_KEY);
  } catch {
    // нечего чистить
  }
}
